import { NextSeo } from "next-seo";
import SimpleFooter from "components/SimpleFooter";
import SimpleNavbar from "components/SimpleNavbar";
import Link from "next/link";

const ProtectYourselfFromJobScams = () => {
  return (
    <>
      <NextSeo
        title="Teamshares | Protect Yourself From Job Scams"
        description="Teamshares will never ask for money or fees during the interview process. Protect yourself from scams which can appear like legitimate work opportunities."
      />
      <div className="min-h-screen antialiased leading-normal text-gray-900 bg-white">
        <SimpleNavbar />
        <div className="max-w-6xl px-12 mx-auto text-sm lg:text-lg">
          <div className="mb-10 text-3xl font-bold pt-28 md:text-4xl">
            Protect Yourself From Job Scams
          </div>
          Here is how to protect yourself from job scams, which can appear like
          legitimate work opportunities, where the scammer pretends to work at
          Teamshares:
          <div className="mt-2 lg:mt-4"></div>
          <span className="font-bold">
            Teamshares will never ask for money or fees at any point during the
            interview process;
          </span>{" "}
          if you are being asked to send money or electronics as part of your
          interaction, do not send it.
          <div className="mt-2 lg:mt-4"></div>
          <span className="font-bold">
            Teamshares never asks applicants to communicate through Wire,
            Telegram, Skype, or other chat apps.
          </span>{" "}
          If you are being asked to download a chat app for a job interview, do
          not download.
          <div className="mt-2 lg:mt-4"></div>
          <span className="font-bold">Genuine Teamshares email</span> comes only
          from @teamshares.com email addresses.
          <div className="mt-2 lg:mt-4"></div>
          <span className="font-bold">
            Teamshares posts all legitimate job openings on our careers website.
          </span>{" "}
          You may come across job postings on various job boards. For your
          safety, please verify a role exists and apply directly on our website
          at&nbsp;
          <Link href="/careers" target="_blank">
            https://www.teamshares.com/careers
          </Link>
        </div>
        <SimpleFooter />
      </div>
    </>
  );
};

export default ProtectYourselfFromJobScams;
